import { LightMode } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { T } from "@repo/translation";
import { LocalizedDateAndTime } from "@repo/ui";
import { CoWorkerName } from "@repo/ui";

export const HistoryCreatedInfo = ({
  createdBy,
  createdAt,
  withLabel = false,
}: {
  createdBy?: string;
  createdAt: string;
  withLabel?: boolean;
}) => {
  return (
    <div>
      {withLabel && (
        <Text
          tagName="span"
          color={LightMode.colourTextAndIcon3}
          textStyle="Body.S"
        >
          <T translationKey="label.created_by" />
        </Text>
      )}
      {createdBy?.toLowerCase() === "system" ? (
        <Text
          tagName="span"
          color={LightMode.colourTextAndIcon3}
          textStyle="Body.S"
        >
          <T translationKey="label.system" />
        </Text>
      ) : (
        <CoWorkerName
          email={createdBy}
          tagName="span"
          color={LightMode.colourTextAndIcon3}
          textStyle="Body.S"
        />
      )}
      <Text
        tagName="span"
        color={LightMode.colourTextAndIcon3}
        textStyle="Body.S"
      >
        {withLabel ? " · " : " | "}
      </Text>
      <Text
        tagName="span"
        color={LightMode.colourTextAndIcon3}
        textStyle="Body.S"
      >
        <LocalizedDateAndTime date={createdAt} />
      </Text>
    </div>
  );
};
